import { Component } from '@angular/core';
import { ModalController } from '@ionic/angular';
import { Store } from '@ngrx/store';
import { map, Observable } from 'rxjs';

import { AppState } from './../../../store/app-reducers';

@Component({
    selector: 'app-reward-modal',
    templateUrl: './reward-modal.page.html',
    styleUrls: ['./reward-modal.page.scss']
})
export class RewardModalPage {

    public Programa: Observable<number>;

    constructor(
        private modalCtrl: ModalController
        , private store: Store<AppState>
    ) {
        this.Programa = this.store.select('userData').pipe(map(value => value.ID_Programa));
    }

    public onClose = () => this.modalCtrl.dismiss(0);

}
